// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_n3-0";
export var discountCodeInput = "_n3-1";